<template>
  <div>
    <div class="container-fluid my-account">
      <div class="row">
        <div class="col-md-12 page_title">Address</div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div
            class="success_message"
            v-text="this.$root.success_message"
            v-if="this.$root.success_message != ''"
          ></div>
          <div
            class="error_message"
            v-text="this.$root.error_message"
            v-if="this.$root.error_message != ''"
          ></div>
        </div>
        <div class="col-md-2 account_sidebar">
          <ul class="sidebar">
            <li class="sidebar_list active">
              <router-link :to="{ name: 'dashboard' }">OverView</router-link>
            </li>
            <li class="sidebar_list">
              <h4 class="sidebar_heading">Orders & returns</h4>
              <router-link :to="{ name: 'order' }">My Orders</router-link>
            </li>
            <li class="sidebar_list">
              <h4 class="sidebar_heading">Account</h4>
              <router-link :to="{ name: 'profile' }">Profile</router-link>
              <!-- <router-link :to="{name:'address_book'}">Saved Cards</router-link> -->
              <router-link :to="{ name: 'address_book' }">Address</router-link>
            </li>
            <li class="sidebar_list">
              <h4 class="sidebar_heading">Credits</h4>
              <router-link :to="{ name: 'StoreCredit' }"
                >WNDW Credits</router-link
              >
            </li>
          </ul>
        </div>
        <div class="col-md-10" v-if="addressLoader">
        		<PuSkeleton  class=" Skeleton1"  width="100%" height="inherit" />
        		<PuSkeleton  class=" Skeleton2"  width="100%" height="inherit" />
            <PuSkeleton  class=" Skeleton3"  width="100%" height="inherit" />
        		<PuSkeleton  class=" Skeleton4"  width="100%" height="inherit" />
        </div>
        <div class="col-md-10" v-else>
          <div class="row">
            <div class="col-md-12">
              <h4 class="main-heading">Default Shipping Address</h4>
              <div class="row">
              <div class="col-md-4"  v-if="this.shipping_address.address != ''">
                <div class="shipping-address-item">
                    <div class="address">
                  <span v-text="this.shipping_address.name"></span><br>
                  <span v-text="this.shipping_address.city"></span><br>
                  <span
                    v-text="
                      this.shipping_address.address +
                      ', ' +
                      this.shipping_address.state +
                      ', ' +
                      this.shipping_address.pincode
                    "
                  ></span><br>
                  <!-- <p v-text="this.shipping_address.email"></p> -->
                  <span v-text="this.shipping_address.phone"></span><br>
                  </div>
                  <button
                  type="button"
                    @click.prevent="
                      edit_address(
                        shipping_address.address_id,
                        shipping_address.name,
                        shipping_address.address,
                        shipping_address.city,
                        shipping_address.state,
                        shipping_address.pincode,
                        shipping_address.phone,
                        shipping_address.default,
                        shipping_address.address_type,
                        shipping_address.flat_no,
                        shipping_address.landmark
                      )
                    "
                    class="action action-select-shipping-item ">
                    <span>Edit Address</span>
                  </button>
                </div>
              </div>
              <div class="content-box col-md-4" v-else>
                <p>No Address found</p>
              </div>
              <div class="col-md-4">
                    <div class="shipping-address-item newAddress"  @click.prevent="newAddresShowFun">
                        <div class="newAddressBox">
                            <i class="fa fa-plus"></i>
                            <p>Add New Address</p>
                        </div>
                    </div>
              </div>
              </div>
            </div>
            <div class="col-md-12">
              <!-- <h4 class="main-heading add-address-icon">
                <a href="#" @click.prevent="newAddresShowFun">
                  <span>Add New Address </span><i class="fa fa-plus"></i
                ></a>
              </h4> -->
              <div class="new_address_book" v-if="newAddresShow">
                <form class="newAddress-form">
                  <div class="row mt-4">
                    <div class="form-group col-md-6 col-12">
                      <input
                        maxlength="10"
                        class="input-text form-control"
                        autocomplete="off"
                        placeholder="Enter Mobile Number*"
                        name="new_mobile"
                        autofocus
                        v-model="user.phone"
                        @keyup="user_phone"
                      />
                      <p
                        class="size_error"
                        v-text="this.phone_error"
                        v-if="this.phone_error"
                      ></p>
                    </div>
                    <div class="form-group col-md-6 col-12">
                      <input
                        class="input-text form-control"
                        type="text"
                        autocomplete="off"
                        placeholder="Full Name*"
                        name="full_name"
                        required=""
                        @keyup="user_name"
                        v-model="user.name"
                      />
                      <p
                        class="size_error"
                        v-text="this.name_error"
                        v-if="this.name_error"
                      ></p>
                    </div>
                    <div class="form-group col-md-6 col-12">
                      <input
                        class="input-text form-control"
                        type="email"
                        autocomplete="off"
                        placeholder="Email*"
                        name="Email"
                        required=""
                        v-model="user.email"
                        @keyup="user_email"
                      />
                      <p
                        class="size_error"
                        v-text="this.email_error"
                        v-if="this.email_error"
                      ></p>
                    </div>
                    <div class="form-group col-md-6 col-12">
                      <input
                        class="input-text form-control"
                        autocomplete="off"
                        placeholder="Street Address*"
                        type="text"
                        name="street_address"
                        required=""
                        v-model="user.address"
                        @keyup="user_address"
                      />
                      <p
                        class="size_error"
                        v-text="this.address_error"
                        v-if="this.address_error"
                      ></p>
                    </div>
                    <div class="form-group col-md-6 col-12">
                      <input
                        class="input-text form-control"
                        type="text"
                        autocomplete="off"
                        placeholder="PIN Code*"
                        name="pin_code"
                        id="postcode"
                        maxlength="6"
                        required=""
                        v-model="user.pin_code"
                        @keyup="user_pin_code"
                      />
                      <p
                        class="size_error"
                        v-text="this.pin_code_error"
                        v-if="this.pin_code_error"
                      ></p>
                    </div>
                    <div class="form-group col-md-6 col-12">
                      <input
                        class="input-text form-control"
                        autocomplete="off"
                        placeholder="City*"
                        type="text"
                        name="city"
                        id="city"
                        required=""
                        v-model="user.city"
                        @keyup="user_city"
                      />
                      <p
                        class="size_error"
                        v-text="this.city_error"
                        v-if="this.city_error"
                      ></p>
                    </div>
                    <div class="form-group col-md-6 col-12">
                      <input
                        class="input-text form-control"
                        autocomplete="off"
                        placeholder="State*"
                        type="text"
                        name="state"
                        id="state"
                        required=""
                        v-model="user.state"
                      />
                      <!-- <p class="size_error" v-text="this.city_error" v-if="this.city_error"></p> -->
                    </div>
                    <div class="form-group col-md-6 col-12">
                      <div class="row">
                        <label class="font-medium col-6"
                          >Select Address Type</label
                        >
                        <div class="col-6 address_type_container">
                          <label for="home">
                           
                            <input
                              type="radio"
                              @change="address_type_change($event)"
                              id="home"
                              name="Type"
                              value="home"
                              :checked="this.user.address_type == 'home'"
                            />
                            Home</label
                          >
                          <label
                            class="ml-3"
                            for="office"
                            :class="{
                              addressTypeActive:
                                this.user.address_type == 'office',
                            }"
                          >
                          
                            <input
                              type="radio"
                              @change="address_type_change($event)"
                              id="office"
                              name="Type"
                              value="office"
                              :checked="this.user.address_type == 'office'"
                            />
                            Office</label
                          >
                          <label
                            class="ml-3"
                            for="Others"
                            :class="{
                              addressTypeActive:
                                this.user.address_type != 'office' || this.user.address_type != 'home',
                            }"
                          >
                          
                            <input
                              type="radio"
                              @change="address_type_change($event)"
                              id="others"
                              name="Type"
                              value="others"
                              :checked="this.user.address_type == 'others'"
                            />
                            Others</label
                          >
                        </div>
                        <div class="col-6"> </div>
                        <div class="col-6" v-if="user.address_type == 'others'"> <input v-model="otherAddressType" type="text" class="form-control"> </div>
                      </div>
                      <p
                        class="size_error"
                        v-text="this.address_type_error"
                        v-if="this.address_type_error"
                      ></p>
                    </div>
                    <div class="col-md-12 text-right mFixed">
                      <button
                        type="submit"
                        class="btn shippingBtn text-white px-5"
                        @click.prevent="checkAddAddress()"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="col-md-12">
              <h4 class="main-heading">Additional Address Entries</h4>
              <div class="content-box">
                <div class="row">
                  <div
                    class="col-md-4 col-sm-6 col-xs-12"
                    v-for="(items, index) in address"
                    :key="index"
                  >
                    <div class="shipping-address-item">
                      <div class="address">
                        <span v-text="items.full_name"></span> <br /><span
                          v-text="items.city"
                        ></span>
                        <br /><span v-text="items.street_address"></span>,
                        <span v-text="items.state"></span>,
                        <span v-text="items.pin_code"></span><br />
                        <span v-text="'Mobile: ' + items.phone"></span><br />
                        <span v-if="items.address_type"
                          >Address type: {{ items.address_type }}</span
                        >
                      </div>
                      
                      <button
                        type="button"
                        class="action action-select-shipping-item float-left mr-3"
                        :value="index"
                        @click="
                          edit_address(
                            items.id,
                            items.full_name,
                            items.street_address,
                            items.city,
                            items.state,
                            items.pin_code,
                            items.phone,
                            items.default,
                            items.address_type,
                            items.flat_no,
                            items.landmark
                          )
                        "
                >
                        <span>Edit Address</span>
                      </button>
                       <button @click="OpenDeletePopup(items.id)"> Delete </button>
                       <button @click="setDefaultAdress(items.id)"> Set Default </button>
                    </div>
                  </div>
                </div>
                <p v-if="!address.length">No Address found</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="coupon-modal"
        class="modal"
        v-bind:class="[this.address_popup ? '' : 'active']"
      >
      <div class="overFlow" @click="close_popup()"></div> 
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title font-bold">Edit Address</h4>
              <button type="button" class="close" @click="close_popup()">
                ×
              </button>
            </div>
            <div class="modal-body">
              <form class="new-address-form opc-section">
                <div
                  class="field full-name"
                  v-bind:class="{
                    success: this.name_error == '',
                    error: this.name_error != '',
                  }"
                >
                  <label class="label"><span>Full Name</span></label>
                  <input
                    class="input-text form-control"
                    v-model="user.name"
                    autocomplete="off"
                    @keyup="user_name"
                    type="text"
                    name="full_name"
                    required=""
                  />
                  <p class="size_error" v-text="this.name_error"></p>
                </div>
                <div
                  class="field street-address"
                  v-bind:class="{
                    success: this.address_error == '',
                    error: this.address_error != '',
                  }"
                >
                  <label class="label"><span>Street Address</span></label>
                  <input
                    class="input-text form-control"
                    v-model="user.address"
                    autocomplete="off"
                    @keyup="user_address"
                    type="text"
                    name="street_address"
                    required=""
                  />
                  <p class="size_error" v-text="this.address_error"></p>
                </div>
                <div
                  class="field pin-code"
                  v-bind:class="{
                    success: this.pin_code_error == '',
                    error: this.pin_code_error != '',
                  }"
                >
                  <label class="label"><span>PIN Code</span></label>
                  <input
                    class="input-text form-control"
                    type="text"
                    autocomplete="off"
                    @keyup="user_pin_code"
                    v-model="user.pin_code"
                    name="pin_code"
                    id="postcode"
                    maxlength="6"
                    required=""
                  />
                  <p class="size_error" v-text="this.pin_code_error"></p>
                </div>
                <div
                  class="field city"
                  v-bind:class="{
                    success: this.city_error == '',
                    error: this.city_error != '',
                  }"
                >
                  <label class="label"><span>City</span></label>
                  <input
                    class="input-text form-control"
                    type="text"
                    autocomplete="off"
                    @keyup="user_city"
                    v-model="user.city"
                    name="city"
                    id="city"
                    required=""
                  />
                  <p class="size_error" v-text="this.city_error"></p>
                </div>
                <div
                  class="field state"
                  v-bind:class="{
                    success: this.state_error == '',
                    error: this.state_error != '',
                  }"
                >
                  <label class="label"><span>State</span></label>
                  <input
                    class="input-text form-control"
                    type="text"
                    autocomplete="off"
                    v-model="user.state"
                    name="state"
                    id="state"
                    required=""
                    disabled
                  />
                </div>
                <div
                  class="field receiver-phone"
                  v-bind:class="{
                    success: this.phone_error == '',
                    error: this.phone_error != '',
                  }"
                >
                  <label class="label"
                    ><span>Receiver Phone Number</span></label
                  >
                  <input
                    class="input-text form-control"
                    maxlength="10"
                    autocomplete="off"
                    @keyup="user_phone"
                    v-model="user.phone"
                    type="text"
                    name="phone"
                    required=""
                  />
                  <p class="size_error" v-text="this.phone_error"></p>
                </div>
                <div class="field address_type_container">
                  <label>Select Address Type</label>
                  <div class="row">
                    <div class="col-4">
                      <label for="home"
                        ><input
                          type="radio"
                          @change="address_type_change($event)"
                          id="home"
                          name="Type"
                          value="home"
                          :checked="this.user.address_type == 'home'"
                        />
                        Home</label
                      >
                    </div>
                    <div class="col-4">
                      <label for="office"
                        ><input
                          type="radio"
                          @change="address_type_change($event)"
                          id="office"
                          name="Type"
                          value="office"
                          :checked="this.user.address_type == 'office'"
                        />Office</label
                      >
                    </div>
                    <div class="col-4">
                      <label for="others"
                        ><input
                          type="radio"
                          @change="address_type_change($event)"
                          id="others"
                          name="Type"
                          value="others"
                          :checked="this.user.address_type == 'others'"
                        />Others</label
                      >
                      <div v-if="user.address_type == 'others'"> <input v-model="otherAddressType" type="text" class="form-control w-100"> </div>
                    </div>
                  </div>
                </div>
                <div class="field submit">
                  <button
                    type="button"
                    @click="checkEditAddress"
                    v-ripple
                    class="continue"
                  >
                    <span>Update Address</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- map new address -->
    <div
      class="modal size-guide-popup-container"
      v-bind:class="{ active: this.isMap === false }"
      id="coupon-modal"
      v-if="!this.isMap"
    >
      <!-- @click="close_store_popup()" -->
      <div class="modal-dialog">
        <div
          class="modal-content"
          style="border-radius: 6px !important; overflow: hidden"
        >
          <div class="modal-body p-0">
            <!-- class="close" -->
            <!-- @click="close_store_popup()" -->

            <div v-if="!this.isMap">
              <GmapMap
                id="map"
                :center="center"
                :zoom="15"
                :options="{
                  zoomControl: true,
                  mapTypeControl: false,
                  scaleControl: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  disableDefaultUi: false,
                  componentRestrictions: {
                    country: ['in'],
                  },
                }"
                map-type-id="terrain"
                style="width: 100%; height: 500px"
                @click="mark"
              >
                <GmapMarker
                  v-for="(marker, i) in markers"
                  :position="marker.position"
                  :clickable="true"
                  :draggable="true"
                  :key="i"
                  :icon="markerOptions"
                   @dragend="setCenter"
                  
                />
              </GmapMap>

              <h4 class="mapPopHeading p-3">
                Set your delivery location
                <button
                  type="button"
                  class="close"
                  style=""
                  @click="isMap = true; isEditAddress = false"
                >
                  &times;
                </button>
              </h4>

              <p class="locationAddress">
                {{ this.user.address }}, {{ this.user.city }},
                {{ this.user.pin_code }}
              </p>
              <div class="form-row">
              <input  type="text "  class=" locationAddress form-control" @keyup="checkFlatNumber" style="width: 40%;"  v-model="user.flat_no"
               placeholder="House No./Flat No./Floor" />
              <input  type="text "  class=" locationAddress form-control" @keyup="checkFlatNumber" style="width: 45%;" v-model="user.landmark"
               placeholder="LandMark" /> </div>
               <p v-show="errorFlat" class="text-danger ml-3"> {{errorFlat}} </p>

              <button
                type="submit"
                class="btn shippingBtn text-white float-right mx-4 mb-3"
                @click.prevent="confirmAndProceed()"
              >
                Confirm and Proceed
              </button>
            </div>
                
            <!-- <Login /> -->
          </div>
        </div>
      </div>
    </div>
    <!-- map new addressend -->
    	<!-- delete popup  start-->
		<div
			class="modal"
			v-bind:class="[isDeletePopup ? 'active' : '']"
			id="coupon-modal"
		>
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header p-4">
						<h4 class="modal-title font-bold"> Alert</h4>
						<button type="button" class="close" @click="isDeletePopup = false">
							&times;
						</button>
					</div>
					<!-- Modal body -->
					<div class="modal-body p-4" style="max-height: 80vh; overflow-y: auto">
						<div class="couponsForm-base-couponsPageContainer">
							<div role="tablist">
								<div
									class="block discount active"
									id="block-discount"
									data-collapsible="true"
									role="tab"
									aria-selected="true"
									aria-expanded="true"
									tabindex="0"
								>
									<div id="discount-coupon-form">
										<div class="fieldset coupon">
											
										</div>
									</div>
								</div>
								<div class="couponsForm-base-errorMessage"></div>
							</div>
							<div class="couponsForm-base-boundary"></div>
							<div
								class="couponsForm-base-container"
								
							>
						
								<div class="couponsForm-base-couponsTitle pt-0">
								  Are you sure want to delete this address ?  
								</div>
							
							</div>
							<div  class="couponsForm-base-container">
								<div class="text-center p-5">
								
								<button
								v-ripple
								@click="isDeletePopup = false"
								class="continue float-right themeBtn "
							
								type="button"
							>
								<span>No </span>
							</button>
								<button
								v-ripple
								@click="deleteAddress"
								class="continue float-right themeBtn mr-3"
							
								type="button"
							>
								<span>Yes </span>
							</button>

								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
			<!-- delete popup end -->
  </div>
</template>

<script>
import axios from "axios";
import GoogleMap from "../GoogleMap";
export default {
  components: {
    GoogleMap,
  },
  name: "address_book",
  metaInfo: {
    title: "Address book",
    meta: [
      {
        name: "description",
        content:
          "Online fashion shopping destination for the modern women. Buy latest collection of online ethnic wear for women’s, W Kurtas, dresses, bottom wear, tops, palazzos, culottes, skirts, drapes and more.",
      },
      {
        property: "keywords",
        content:
          "Online Shopping for Women,  W for Woman, women’s dresses online, buy women’s dresses online",
      },
    ],
  },
  data() {
    return {
      addressLoader:true,
      errorFlat: '',
      deleteId: '',
      isDeletePopup: false,
      isEditAddress: false,
      markerOptions: {
					url: '/img/pin-map-location.png',
					size: {width: 58, height: 50, f: 'px', b: 'px',},
					scaledSize: {width: 55, height: 50, f: 'px', b: 'px',},
			},
      address: [],
      shipping_address: {
        address_id: "",
        name: "",
        address: "",
        pincode: "",
        city: "",
        state: "",
        phone: "",
        default: "",
        flat_no: '',
        landmark: ''
      },
      address_popup: true,
      address_error: "",
      name_error: "",
      pin_code_error: "",
      city_error: "",
      state_error: "",
      phone_error: "",
      selected_address_pincode: "",
      user: {
        flat_no:'',
        landmark: '',
        address_id: "",
        name: "",
        address: "",
        pin_code: "",
        city: "",
        state: "",
        phone: "",
        default: "",
        address_type: "Home",
      },

      // new addres var
      new_mobile_number: "",
      email_error: "",
      address_type_error: "",
      newAddresShow: false,
      isMap: true,
      error: "",
      center: {
        lat: parseInt(this.$root.location.lat),
        lng: parseInt(this.$root.location.long),
      },
      markers: [
        {
          position: {
            lat: parseInt(this.$root.location.lat),
            lng: parseInt(this.$root.location.long),
          },
        },
      ],
    };
  },
  methods: {
    OpenDeletePopup (id) {
      this.deleteId = id
      this.isDeletePopup = true

    },
    setDefaultAdress (id) {
      this.$root.page_loader = true;
        var form = new FormData();
       form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("address_id", id);
        axios
          .post(this.$root.cart_api + "/customer/default-address", form)
          .then((response) => {
            if (response.data.success === true) {
             
              this.$root.page_loader = false;
               this.address = response.data.data;
                let defaultAddress = response.data.data.find(x => x.default == 1)
                this.shipping_address.address_id = defaultAddress.id;
                this.shipping_address.name =  defaultAddress.full_name;
                this.shipping_address.address =  defaultAddress.street_address;
                this.shipping_address.pincode = defaultAddress.pin_code;
                this.shipping_address.city = defaultAddress.city;
                this.shipping_address.state = defaultAddress.state;
                this.shipping_address.phone = defaultAddress.phone;
                this.shipping_address.default =  defaultAddress.default;
                this.shipping_address.address_type =  defaultAddress.address_type;
                this.shipping_address.flat_no =  defaultAddress.flat_no;
                this.shipping_address.landmark =  defaultAddress.landmark ? defaultAddress.landmark : '';
               this.$toast.success(response.data.message, {
                position: "top-right",
                duration: 4000,
              });
             
            } else {
                 this.isDeletePopup = false
               this.$toast.error(response.data.message, {
                position: "top-right",
                duration: 4000,
              });
              this.$root.page_loader = false;
              this.$root.error_message = response.data.message;
              
              
            }
          })
          .catch((error) => {
            this.isDeletePopup = false
            this.$root.page_loader = false;
            this.$toast.error(response.data.message, {
                position: "top-right",
                duration: 4000,
              });
            if (error.message === "Network Error") {
              this.$root.error_message = error.message;
            }
            window.scrollTo(0, 0);
          });
      
     // default address 
    },
    deleteAddress () {
      this.$root.page_loader = true;
        var form = new FormData();
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("address_id", this.deleteId);
        axios
          .post(this.$root.cart_api + "/customer/delete-address", form)
          .then((response) => {
            if (response.data.success === true) {
              this.isDeletePopup = false
              this.$root.page_loader = false;
               this.address = response.data.data;
               this.$toast.success(response.data.message, {
                position: "top-right",
                duration: 4000,
              });
             
            } else {
                 this.isDeletePopup = false
               this.$toast.error(response.data.message, {
                position: "top-right",
                duration: 4000,
              });
              this.$root.page_loader = false;
              this.$root.error_message = response.data.message;
              
              
            }
          })
          .catch((error) => {
            this.isDeletePopup = false
            this.$root.page_loader = false;
            this.$toast.error(response.data.message, {
                position: "top-right",
                duration: 4000,
              });
            if (error.message === "Network Error") {
              this.$root.error_message = error.message;
            }
            window.scrollTo(0, 0);
          });
      
     // delete address 
    },
    setCenter(marker) {
     
      this.markers[0].position.lat =marker.latLng.lat();
      this.markers[0].position.lng = marker.latLng.lng();
      this.$root.location.lat = marker.latLng.lat();
      this.$root.location.long = marker.latLng.lng();
      this.reverseGeocodeText()
      
    },
    	reverseGeocodeText() {
				const that = this;
				// console.log(this.$root.location.lat);
				axios
					.get(
						`https://maps.google.com/maps/api/geocode/json?latlng=${this.$root.location.lat},${this.$root.location.long}&key=AIzaSyABzA9XnM_g51esLxbDQdAdZAjtz3wjIMc`
					)
					.then((response) => {
					   response.data.results[0].formatted_address.split(",");
             this.user.pin_code = response.data.results[0].address_components[response.data.results[0].address_components.length - 1].long_name
             this.user.city = response.data.results[0].address_components[3].long_name
             this.user.address = `${response.data.results[0].address_components[0].long_name}, ${response.data.results[0].address_components[1].long_name}`
				
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => (this.loading = false));
			},
    address_type_change(event) {
      this.user.address_type = event.target.value;
    },
    close_popup: function () {
      this.isEditAddress = false
      this.address_popup = true;
    },
    edit_address: function (
      id,
      name,
      address,
      city,
      state,
      pin,
      phone,
      add_default,
      address_type,
      flat_no,
      landmark
    ) {
      this.user.address_id = id;
      if (address_type != null) {
        this.user.address_type = address_type;
        if(address_type != 'home' && address_type != 'office') {
          this.user.address_type = 'others'
          this.otherAddressType = address_type
        } else {
          this.user.address_type = address_type;	}
      } else {
        this.user.address_type = "home";
      }
      this.isEditAddress = true
      this.user.name = name;
      this.user.address = address;
      this.user.pin_code = pin;
      this.user.city = city;
      this.user.state = state;
      this.user.phone = phone;
      this.user.flat_no = flat_no;
      this.user.landmark = landmark ? landmark :"";
      this.user.default = add_default;
      this.address_popup = false;
      this.user_name();
      this.user_city();
      this.user_address();
      this.user_pin_code();
      this.user_phone();
    },
    user_name: function () {
      var name = /^([^\s]+[a-z ,A-Z, ])+$/;
      if (this.user.name.match(name)) {
        this.name_error = "";
      } else {
        this.name_error = "Please enter valid Name";
      }
    },
    user_city: function () {
      var city = /^([^\s]+[a-z ,A-Z, ])+$/;
      if (this.user.city.match(city)) {
        this.city_error = "";
      } else {
        this.city_error = "Please enter valid City";
      }
    },
    user_address: function () {
      var address = /^([^\s]+[a-z A-Z 1-9])+$/;
      if (this.user.address.length > 3) {
        this.address_error = "";
      } else {
        this.address_error = "Please enter valid Address";
      }
    },
    user_pin_code: function () {
      var pin_code = /^([0-9]{6,})+$/;
      if (this.user.pin_code.match(pin_code)) {
        axios
          .get(this.$root.api_url + `/pim/pimresponse.php`, {
            params: {
              service: "pincheck",
              store: this.$root.store,
              pincode: this.user.pin_code,
            },
          })
          .then((response) => {
            if (response.data.result == "") {
              this.pin_code_error = "Sorry this pincode is not serviceable.";
            } else {
              this.user.city = response.data.result.city;
              this.user.state = response.data.result.state;
              this.pin_code_error = "";
              this.state_error = "";
              if (response.data.result.city != "") {
                this.city_error = "";
              }
            }
          });
      } else {
        this.pin_code_error = "Please enter valid Pin code";
      }
    },
    user_phone: function () {
      var phoneno = /^([0-9]{10,})+$/;
      if (this.user.phone.match(phoneno)) {
        this.phone_error = "";
      } else {
        this.phone_error = "Please enter valid Phone Number";
      }
    },
    user_email() {
      // console.log("called");
      var email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.user.email.match(email)) {
        this.email_error = "";
      } else {
        this.email_error = "Please enter valid Email";
      }
    },
    update_address: function () {
      if (
        this.user.name != "" &&
        this.user.address != "" &&
        this.user.pin_code != "" &&
        this.user.city != "" &&
        this.user.state != "" &&
        this.user.phpne != "" &&
        this.name_error == "" &&
        this.address_error == "" &&
        this.pin_code_error == "" &&
        this.city_error == "" &&
        this.state_error == "" &&
        this.phone_error == ""
      ) {
        this.$root.error_message = "";
        this.$root.success_message = "";
        this.$root.page_loader = true;
        var form = new FormData();
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("address_id", this.user.address_id);
        form.append("full_name", this.user.name);
        form.append("street_address", this.user.address);
        form.append("pin_code", this.user.pin_code);
        form.append("city", this.user.city);
        form.append("flat_no", this.user.flat_no);
        form.append("landmark", this.user.landmark);
        form.append("state_name", this.user.state);
        form.append("phone", this.user.phone);
        form.append("default", this.user.default);
        if(this.otherAddressType != '' && this.user.address_type == 'others') {
          form.append("address_type", this.otherAddressType);
        } else {
          form.append("address_type", this.user.address_type);
        }
        
        form.append("lat", this.markers[0].position.lat);
        form.append("lng", this.markers[0].position.lng);
        axios
          .post(this.$root.cart_api + "/customer/edit-address", form)
          .then((response) => {
            if (response.data.success === true) {
              this.isMap = true;
              // console.log("id",this.$root.customer_id);
              this.$root.success_message = response.data.message;
              this.address = response.data.data.address;
              this.$root.error_message = "";
              this.$root.page_loader = false;
              this.address_popup = true;
             let defaultAddress = response.data.data.address.find(x => x.default == 1)
              this.shipping_address.address_id = defaultAddress.id;
              this.shipping_address.name =  defaultAddress.full_name;
              this.shipping_address.address =  defaultAddress.street_address;
              this.shipping_address.pincode = defaultAddress.pin_code;
              this.shipping_address.city = defaultAddress.city;
              this.shipping_address.state = defaultAddress.state;
              this.shipping_address.phone = defaultAddress.phone;
              this.shipping_address.default =  defaultAddress.default;
              this.shipping_address.address_type =  defaultAddress.address_type;
              this.shipping_address.flat_no =  defaultAddress.flat_no;
              this.shipping_address.landmark =  defaultAddress.landmark ? defaultAddress.landmark : '';
              window.scrollTo(0, 0);
            } else {
              this.$root.error_message = response.data.message;
              this.$root.success_message = "";
              this.$root.page_loader = false;
              if (response.data.customer_session_status == false) {
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                this.$root.cart_id = "";
                this.$root.cart_session = "";
                this.$root.cart_product = [];
                this.$router.push("/");
              }
            }
          })
          .catch((error) => {
            this.$root.page_loader = false;
            if (error.message === "Network Error") {
              this.$root.error_message = error.message;
            }
            window.scrollTo(0, 0);
          });
      }
    },
    get_account: function () {
      if (this.$root.customer_id != null && this.$root.customer_id != "") {
        this.$root.error_message = "";
        this.$root.success_message = "";
        this.$root.page_loader = true;
        var form = new FormData();
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("store", this.$root.store);
        axios
          .post(this.$root.cart_api + "/customer/account-details", form)
          .then((response) => {
            if (response.data.success === true) {
              this.$root.page_loader = false;
              this.address = response.data.data.address;
              let defaultAddress = response.data.data.address.find(x => x.default == 1)
              this.shipping_address.address_id = defaultAddress.id;
              this.shipping_address.name =  defaultAddress.full_name;
              this.shipping_address.address =  defaultAddress.street_address;
              this.shipping_address.pincode = defaultAddress.pin_code;
              this.shipping_address.city = defaultAddress.city;
              this.shipping_address.state = defaultAddress.state;
              this.shipping_address.phone = defaultAddress.phone;
              this.shipping_address.default =  defaultAddress.default;
              this.shipping_address.address_type =  defaultAddress.address_type;
              this.shipping_address.flat_no =  defaultAddress.flat_no;
                this.shipping_address.landmark =  defaultAddress.landmark  ? defaultAddress.landmark : '';
            } else {
              this.$root.page_loader = false;
              this.$root.error_message = response.data.message;
              if (response.data.customer_session_status == false) {
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cs",
                  "",
                  "1y"
                );
                this.$root.customer_id = "";
                this.$root.customer_session = "";
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                this.$cookies.set(
                  window.location.hostname.substring(10, 4) + "_carts",
                  "",
                  "1y"
                );
                this.$root.cart_id = "";
                this.$root.cart_session = "";
                this.$root.cart_product = [];
                this.$router.push("/");
              }
            }
            this.addressLoader = false;
          })
          .catch((error) => {
            this.$root.page_loader = false;
            if (error.message === "Network Error") {
              this.$root.error_message = error.message;
            }
            window.scrollTo(0, 0);
          });
      }
    },

    //   new address add code
    newAddresShowFun: function () {
      this.newAddresShow = !this.newAddresShow;
    },
    checkAddAddress () {
				if (
					this.user.address_type != "" &&
					this.user.name != "" &&
					this.user.address != "" &&
					this.user.pin_code != "" &&
					this.user.city != "" &&
					this.user.state != "" &&
					this.user.phone != "" &&
					this.user.email != "" &&
					this.name_error == "" &&
					this.address_error == "" &&
					this.pin_code_error == "" &&
					this.city_error == "" &&
					this.state_error == "" &&
					this.email_error == "" &&
					this.phone_error == "" &&
					this.address_type_error == ""
				) { this.reverseGeocode () }
				else {
					this.user_name();
					this.user_email();
					this.user_phone();
					this.user_pin_code();
					this.user_address();
					this.user_city();
					if (this.user.address_type == "") {
						this.address_type_error = "Please select an address type";
					} else {
						this.address_type_error = "";
					}
				}


			},
      checkEditAddress () {
				if (
        this.user.name != "" &&
        this.user.address != "" &&
        this.user.pin_code != "" &&
        this.user.city != "" &&
        this.user.state != "" &&
        this.user.phpne != "" &&
        this.name_error == "" &&
        this.address_error == "" &&
        this.pin_code_error == "" &&
        this.city_error == "" &&
        this.state_error == "" &&
        this.phone_error == ""
				) { this.reverseGeocode () }
				

			},

    reverseGeocode() {
     this.address_popup = true;
      if (
        this.user.address_type != "" &&
        this.user.name != "" &&
        this.user.address != "" &&
        this.user.pin_code != "" &&
        this.user.city != "" &&
        this.user.state != "" &&
        this.user.phone != "" &&
        this.name_error == "" &&
        this.address_error == "" &&
        this.pin_code_error == "" &&
        this.city_error == "" &&
        this.state_error == "" &&
        this.email_error == "" &&
        this.phone_error == "" &&
        this.address_type_error == ""
      ) {
        // console.log("uer this", this.user);
        const that = this;
        axios
          .get(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(`${this.user.address}`)},${this.user.city}, ${this.user.pin_code},
														&key=AIzaSyABzA9XnM_g51esLxbDQdAdZAjtz3wjIMc`
          )
          .then((response) => {
            
            // console.log("response", response.data.results[0].geometry.location.lng);
            // console.log("response", response.data.results[0].geometry.location.lat);
            this.isMap = false;
            if (response.data.status == 'OK') {
               this.$root.location.lat =
              response.data.results[0].geometry.location.lat;
            this.$root.location.long =
              response.data.results[0].geometry.location.lng;
            this.markers[0].position.lat =
              response.data.results[0].geometry.location.lat;
            this.markers[0].position.lng =
              response.data.results[0].geometry.location.lng;
            this.center = {
              lat: response.data.results[0].geometry.location.lat,
              lng: response.data.results[0].geometry.location.lng,
            };
            } else {
               this.$toast.warning('Unable to detect exact location of your address. please pin your location on map', {
                position: "top-right",
                duration: 4000,
              });

            }
           
            // this.cityName =
            // 	response.data.results[0].address_components[1].short_name;
            // 	this.$root.cityName = response.data.results[0].formatted_address
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loading = false));
      } else {
        this.user_name();
        this.user_phone();
        this.user_email();
        this.user_pin_code();
        this.user_address();
        this.user_city();
        if (this.user.address_type == "") {
          this.address_type_error = "Please select an address type";
        } else {
          this.address_type_error = "";
        }
      }

      // this.addLocation()
    },
    mark(event) {
     
      let lat = event.latLng.lat();

      let lng = event.latLng.lng();

      this.markers[0].position.lat = lat;
      this.markers[0].position.lng = lng;
      this.$root.location.lat = lat;
      this.$root.location.long = lng;
      this.reverseGeocodeText()
    },
    checkFlatNumber () {
     
     if(this.user.flat_no.length == 0) {
        this.errorFlat = "Please enter Flat/door Number"
      } else {
        this.errorFlat = ''
      }
      


    },
    confirmAndProceed () {
      this.checkFlatNumber()
      if(this.errorFlat.length) {
        return
      }
      if(this.isEditAddress) {
        this.isEditAddress = false
        this.update_address ()
      } else {
        this.new_address()
      }
    },
    new_address: function () {
      if (
        this.user.address_type != "" &&
        this.user.name != "" &&
        this.user.address != "" &&
        this.user.pin_code != "" &&
        this.user.city != "" &&
        this.user.state != "" &&
        this.user.phone != "" &&
        this.user.email != "" &&
        this.name_error == "" &&
        this.address_error == "" &&
        this.pin_code_error == "" &&
        this.city_error == "" &&
        this.state_error == "" &&
        this.email_error == "" &&
        this.phone_error == "" &&
        this.address_type_error == ""
      ) {
        this.$root.error_message = "";
        this.$root.success_message = "";
        this.$root.page_loader = true;
        var form = new FormData();
        form.append("pcart", this.$root.pcart);
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("full_name", this.user.name);
        form.append("street_address", this.user.address);
        form.append("pin_code", this.user.pin_code);
        form.append("city", this.user.city);
        form.append("flat_no", this.user.flat_no);
        form.append("landmark", this.user.landmark);
        form.append("state_name", this.user.state);
        form.append("phone", this.user.phone);
        form.append("email", this.user.email);
        if(this.otherAddressType != '' && this.user.address_type == 'others') {
          form.append("address_type", this.otherAddressType);
        } else {
          form.append("address_type", this.user.address_type);
        }
        form.append("lat", this.markers[0].position.lat);
        form.append("lng", this.markers[0].position.lng);

        let config = { headers: { "Content-Type": "multipart/form-data" } };
        axios
          .post(this.$root.cart_api + "/customer/add-address", form, config)
          .then((response) => {
            // console.log(response);
            if (response.data.success == true) {
                this.$root.page_loader = false;
                this.isMap = true;
              this.$toast.success(response.data.message, {
                position: "top-right",
                duration: 4000,
              });
              this.user = {
                address_id: "",
                name: "",
                address: "",
                pin_code: "",
                city: "",
                state: "",
                phone: "",
                default: "",
                address_type: "",
              };
              this.newAddresShow = false;
              this.$root.page_loader = false;
              this.get_account();
            }
            else {
               this.$toast.error(response.data.message, {
                position: "top-right",
                duration: 4000,
              });
              
            }
          })
          .catch((error) => {
            // console.log("this log");
            this.$root.page_loader = false;
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
            window.scrollTo(0, 0);
          });
      } else {
        this.user_name();
        this.user_phone();
        this.user_pin_code();
        this.user_address();
        this.user_city();
        if (this.user.address_type == "") {
          this.address_type_error = "Please select an address type";
        } else {
          this.address_type_error = "";
        }
      }
    },
  },
    beforeMount(){
    document.addEventListener("keyup", evt => {
				if (evt.keyCode == 27) {
            // alert('adfa');
          this.close_popup(); 
				}
			});
    
  },
  mounted() {
    this.get_account();
  },

  created() {
    window.scrollTo(0, 0);
    if (this.$root.customer_id === null || this.$root.customer_id === "") {
      this.$router.push("/");
    }
    (this.$root.error_message = ""),
      (this.$root.success_message = ""),
      (this.$root.breadcrumb = "Address Book"),
      (this.$root.page_loader = false);
  },
};
</script>


<style scoped>
.locationAddress {
  padding: 10px;
  border: 1px solid rgb(207, 207, 207);
  border-radius: 6px;
  cursor: pointer;
  margin: 0 15px;
  margin-bottom: 18px;
  font-family: "lhmSemiBold";
}
.locationAddress::before {
  content: "\2713";
  width: 20px;
  height: 20px;
  border: 1px solid var(--main-color);
  float: left;
  margin-right: 8px;
  padding-left: 3px;
  border-radius: 50px;
  color: var(--main-color);
}
#coupon-modal .close {
  margin-right: 0px !important;
  z-index: 999;
  position: static;
  opacity: 1;
  font-size: 25px;
}
.Skeleton1, .Skeleton3 {
  height: 40px;
  display: block;
  width: 100%;
  margin: 10px auto;
}
.Skeleton2 ,.Skeleton4 {
  height: 150px;
  display: block;
  width: 100%;
  margin: 10px auto;
}

@media screen and (max-width: 767px) {
  #coupon-modal .close {
    margin-top: -10px !important;
  }
  .Skeleton1 {
    height: 65px;
  }
  .Skeleton2{
    height: 165px;
  } 
  .Skeleton3{
    height: 100px;
    margin-bottom: 100px;

    }
  .Skeleton4 { 
    display: none;

  }
}
</style>